/*
 * @Descripttion: 大多数页面用的header 包含 菜单
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-03-09 15:40:41
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-15 16:00:00
 */
import React from 'react'
import Logo from './images/logo.png'
import {Menu, Dropdown, Avatar} from 'antd'
import {Link, Redirect, withRouter} from 'react-router-dom'
import axios from 'axios'
import './index.css'
import './index_mobile.css'
import {connect} from 'react-redux'
// import { login, logout } from '../../service/loginaction'
import {login, logout} from '../../service/loginaction_yunguan'


class Header3 extends React.Component {
    componentWillUnmount() {
        console.log('Header3----componentWillUnmount当前路由为', window.location.href)
    }

    componentWillMount() {
        console.log('当前路由为', window.location.href)
    }

    componentDidMount() {
    }


    buildMenu = (menuList) => {
        menuList.map((value, index) => {
            return <Menu.Item>
                <Link to={value.link}>{value.menuName}</Link>
            </Menu.Item>
        })
    }

    render() {
        const {SubMenu} = Menu

        const menu1 = (<Menu className="newheader-navigation-menu">
                <Menu.Item>
                    <Link to='/NewsBulletin'>新闻资讯</Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to='/GuideSearch'> 知识库</Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to='/OnlineTraining'>教学中心</Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to='/LiveManager'>在线课堂</Link>
                </Menu.Item>
                <Menu.Item>
                    <Link
                        to={{
                            pathname: '/Q&ACenter',
                            // type: 'center'
                        }}
                    >
                        问答中心</Link>
                </Menu.Item>
            </Menu>
        )
        const menu2 = (<Menu className="newheader-navigation-menu">
                <Menu.Item>
                    <Link to='/Download'>文档资源共享</Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to='/geovis'>数据资源服务</Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to='/sensing'>微波遥感特征库检索</Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to='/CloudStorage'>云盘(资源集成)</Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to='/processdesign' target='_blank'>流程定制</Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to='/DownloadTools'>算法模型</Link>
                </Menu.Item>
                <Menu.Item>
                    <Link to='/onlineApi'>API在线开发</Link>
                </Menu.Item>
            </Menu>
        )
        const usermenu = <Menu className="newheader-navigation-menu">
            <Menu.Item key="1">
                <Link to='/usercenter/myaccount'>个人中心</Link>
            </Menu.Item>
            <Menu.Item key="2">
                <Link to='/CloudStorage'>个人云盘(我的上传)</Link>
            </Menu.Item>
            {/* <Menu.Item key="3" className='header-menuitem' >
                <Link to='/ManagerCenter/AuthorityManager'>管理中心</Link>
            </Menu.Item> */}
            <Menu.Item key='3' className='header-menuitem'>
                <Link to='/chat'>即时通信</Link>
            </Menu.Item>
            <Menu.Item key="4" className='header-menuitem'>
                <Link to='/onlineHelp'>在线帮助</Link>
            </Menu.Item>
            <Menu.Item key="5" className='header-menuitem' style={{color: 'black', lineHeight: '30px'}}>
                <a
                    href={'http://adobe.ossd-zh.kuaiyunds.com/adobe/2xin/ps/photoshopcc2021.zip'}
                    target='_blank'
                >
                    {"客户端下载"}
                </a>
            </Menu.Item>
            <Menu.Item key="6" className='header-menuitem' style={{color: 'black', lineHeight: '30px'}}
                       onClick={() => this.props.logout(this.props.user)}>
                {"退出登录"}
            </Menu.Item>
        </Menu>
        const gxcpmenu = (
            <Menu className="newheader-navigation-menu">
                <SubMenu className="subMenu-gx" title="光学微波卫星共性产品检验">
                    <Menu.Item key="1">
                        <Link to="/CPTJ">产品检验</Link>
                        {/* <Link onClick={this.openWebPage(1)}>产品检验</Link> */}
                    </Menu.Item>
                    <Menu.Item key="2">
                        <Link to="/JYCL">检验处理</Link>
                        {/* <Link onClick={this.openWebPage(2)}>检验处理</Link> */}
                    </Menu.Item>
                    <Menu.Item key="3">
                        <Link to="/FZYZ">仿真验证</Link>
                        {/* <Link onClick={this.openWebPage(3)}>仿真验证</Link> */}
                    </Menu.Item>
                    {/* <Menu.Item>
                <Link to="/bd">xx</Link>
              </Menu.Item> */}
                </SubMenu>
            </Menu>
        );
        const messagemenu = <Menu className="newheader-navigation-menu">
            <Menu.Item key="1">
                <Link to='/userMessage'>消息中心 </Link>
            </Menu.Item>
        </Menu>
        const navigationList1 = [
            {
                key: 1,
                navigatonName: "走进空基",
                type: "menu",
                menuList: [

                    {
                        menuName: "新闻资讯",
                        link: "/NewsBulletin"
                    },
                    {
                        menuName: "知识库",
                        link: "/GuideSearch"
                    },
                    {
                        menuName: "教学中心",
                        link: "/OnlineTraining"
                    },
                    {
                        menuName: "在线课堂",
                        link: "/LiveManager"
                    },
                    {
                        menuName: "问答中心",
                        link: "/Q&ACenter"
                    },
                ],
                link: ''
            },
            {
                key: 2,
                navigatonName: "资源服务",
                type: "menu",
                menuList: [
                    {
                        menuName: "文档资源共享",
                        link: "/Download"
                    },
                    {
                        menuName: "数据资源服务",
                        link: "/geovis"
                    },
                    {
                        menuName: "微波遥感特征库检索",
                        link: "/sensing"
                    },
                    {
                        menuName: "云盘(资源集成)",
                        link: "/CloudStorage"
                    },
                    {
                        menuName: "流程定制",
                        link: "/processdesign"
                    },
                    {
                        menuName: "算法模型",
                        link: "/DownloadTools"
                    },
                    {
                        menuName: "API在线开发",
                        link: "/onlineApi"
                    },
                ],
                link: ""
            },
            {
                key: 3,
                navigatonName: "站网测量",
                type: "link",
                menuList: [],
                link: "/Q&ACenter"
            },
            {
                key: 4,
                navigatonName: "综合实验",
                type: "link",
                menuList: [],
                link: "/ZHSY"
            },
            {
                key: 5,
                navigatonName: "检验服务",
                type: "menu",
                menuList: [
                    {
                        menuName: "产品检验",
                        // link: "https://www.baidu.com/"
                        link: "/CPTJ"
                    },
                    {
                        menuName: "检验处理",
                        // link: "https://www.baidu.com/"
                        link: "/JYCL"
                    },
                    {
                        menuName: "仿真验证",
                        // link: "https://www.baidu.com/"
                        link: "/FZYZ"
                    },
                ],
                link: ""
            },
            {
                key: 6,
                navigatonName: "技术支撑",
                type: "link",
                menuList: [],
                link: "https://www.baidu.com/"
            },
        ]
        const navigationList = [
            {
                key: 1,
                navigatonName: "走进空基",
                type: "menu",
                menuList: [
                    {
                        menuName: "新闻资讯",
                        link: "/NewsBulletin"
                    },
                    {
                        menuName: "知识库*",
                        link: "/GuideSearch"
                    },
                    {
                        menuName: "空基规划",
                        link: "/KJGH"
                    },
                    {
                        menuName: "空基卫星",
                        link: "/KJWX"
                    },
                    {
                        menuName: "共性应用支撑平台",
                        link: "/GXYYZCPT"
                    },
                    {
                        menuName: "项目大事记",
                        link: "/XMDSJ"
                    },
                    {
                        menuName: "团队简介",
                        link: "/TDJS"
                    },
                ],
                link: ''
            },
            {
                key: 2,
                navigatonName: "真实性检验站网",
                type: "menu",
                menuList: [
                    {
                        menuName: "真实性检验站网",
                        type: 'menu',
                        menuList: [
                            {
                                menuName: "光学微波真实性检验站网",
                                link: "/GXWB"
                            },
                            {
                                menuName: "电磁真实性检验站网",
                                link: "/DC"
                            },
                            {
                                menuName: "站点测量任务",
                                link: "/ZDCL"
                            },

                            {
                                menuName: "站点仪器状态管理",
                                link: "/ZDYQ"
                            },
                            {
                                menuName: "站点仪器监控与测量原始数据查看",
                                link: "/ZDYQJK"
                            },
                            {
                                menuName: "站点测量任务管理",
                                link: "/ZDCLRW"
                            },
                            {
                                menuName: "真实性检验站卫星过境管理",
                                link: "/ZSXWXGL"
                            },
                        ]
                    },
                    {
                        menuName: "综合实验场",
                        type: 'menu',
                        menuList: [
                            {
                                menuName: "综合实验场",
                                link: "/ZHSY"
                            },
                            {
                                menuName: "历史试验资料",
                                link: "/LSZL"
                            },
                            {
                                menuName: "实验计划查询",
                                link: "/SYJH"
                            },
                            {
                                menuName: "综合实验任务管理",
                                link: "/ZHSYRW"
                            },
                            {
                                menuName: "综合实验卫星过境管理",
                                link: "/ZHWXGL"
                            },
                        ]
                    },
                    {
                        menuName: "基准与综合实验室",
                        type: 'menu',
                        menuList: [
                            {
                                menuName: "基准与综合实验室",
                                link: "/JZYZHSY"
                            },
                            {
                                menuName: "测量仪器标定",
                                link: "/CLYQ"
                            },
                            {
                                menuName: "仿真分析",
                                link: "/FZFX"
                            },
                        ]
                    },
                    {
                        menuName: "检验数据共享",
                        type: 'menu',
                        menuList: [
                            {
                                menuName: "站网数据预处理",
                                link: "/ZWSJ"
                            },
                            {
                                menuName: "实验数据预处理",
                                link: "/SYSJ"
                            },
                            {
                                menuName: "地面数据精校验",
                                link: "/DMSJ"
                            },
                            {
                                menuName: "真值数据查询",
                                link: "/ZZSJ"
                            },
                            {
                                menuName: "典型数据下载",
                                link: "/DXSJ"
                            },
                        ]
                    },

                    // {
                    //     menuName: "文档资源共享",
                    //     link: "/Download"
                    // },
                    // {
                    //     menuName: "数据资源服务",
                    //     link: "/geovis"
                    // },
                    // {
                    //     menuName: "微波遥感特征库检索",
                    //     link: "/sensing"
                    // },
                    // {
                    //     menuName: "流程定制",
                    //     link: "/processdesign"
                    // },
                    // {
                    //     menuName: "算法模型",
                    //     link: "/DownloadTools"
                    // },
                    // {
                    //     menuName: "API在线开发",
                    //     link: "/onlineApi"
                    // },
                ],
                link: ""
            },
            {
                key: 3,
                navigatonName: "共性产品检验",
                type: "menu",
                menuList: [
                    {
                        menuName: "光学微波产品查询",
                        link: "/GXWBCPCX"
                    },
                    {
                        menuName: "光学微波产品检验服务",
                        link: "/GXWBCPJY"
                    },
                    {
                        menuName: "电磁产品展示",
                        link: "/DCCPCX"
                    },
                    {
                        menuName: "电磁产品检验",
                        link: "/DCCPJY"
                    },
                    {
                        menuName: "基础遥感数据查询",
                        link: "/geovis"
                    },
                    {
                        menuName: "光学微波产品检验处理",
                        link: "/GXWBCL"
                    },
                    {
                        menuName: "检验成果发布",
                        link: "/CloudStorage"
                    },
                    {
                        menuName: "微波遥感特征库检索*",
                        link: "/sensing"
                    },
                ],
                link: ""
            },
            {
                key: 4,
                navigatonName: "共性技术支撑",
                type: "menu",
                menuList: [
                    {
                        menuName: "算法模型共享",
                        link: "/DownloadTools"
                    },
                    {
                        menuName: "共性技术测评",
                        link: "/GXJS"
                    },
                    {
                        menuName: "处理工具共享",
                        link: "/DownloadTools"
                    },
                    {
                        menuName: "处理流程定制",
                        link: "/processdesign"
                    },
                    {
                        menuName: "产品生产定制",
                        link: "/geovis"
                    },
                    {
                        menuName: "API在线开发*",
                        link: "/onlineApi"
                    },
                    {
                        menuName: "智能遥感应用",
                        link: "/ZNYGYY"
                    },
                ],
                link: ""
            },
            {
                key: 5,
                navigatonName: "技术培训交流",
                type: "menu",
                menuList: [
                    {
                        menuName: "标准规范共享",
                        // link: "https://www.baidu.com/"
                        link: "/BZGF"
                    },
                    {
                        menuName: "实验操作培训",
                        // link: "https://www.baidu.com/"
                        link: "/SYCZ"
                    },
                    {
                        menuName: "文档资料共享",
                        // link: "https://www.baidu.com/"
                        link: "/Download"
                    },
                    {
                        menuName: "应用案例",
                        // link: "https://www.baidu.com/"
                        link: "/OnlineTraining"
                    },
                    {
                        menuName: "在线课堂*",
                        link: "/LiveManager"
                    },
                    {
                        menuName: "论坛",
                        // link: "https://www.baidu.com/"
                        link: "/Q&ACenter"
                    },
                ],
                link: ""
            },
            // {
            //     key: 6,
            //     navigatonName: "技术支撑",
            //     type: "link",
            //     menuList: [],
            //     link: "https://www.baidu.com/"
            // },
        ]
        // if (true) {
        // console.log("this.props.user",this.props.user);
        if (this.props.loginObj && this.props.loginObj.login && this.props.loginObj.token !== undefined) {
            return (
                <div className="hidden-scroll" id='token'>
                    <div className={`header-panel headertype-3`}
                    >
                        <div className='header-panel headertype-3_main'>
                            {/* <div className="header-white-panel"></div> */}
                            <div className="header-logo-panel">
                                <Link to='/Guide'>
                                    <img alt='logo' className="header-logo-img" src={Logo}></img>

                                    <div className={'header-title-text'}>
                                        <div className={'header-title-text-cn'}>
                                            {"陆地观测卫星共性应用支撑平台"}
                                        </div>
                                        <div className={'header-title-text-en'}>
                                            {"Common application support platform for land observation satellite"}
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className='header-menu-panel'>
                                <div style={{display: "flex", alignItems: "center"}}>
                                    {/* 导航栏模块循环渲染 */}
                                    {
                                        navigationList.map((value, index) => {
                                            if (value.type === 'menu') {
                                                return <Dropdown
                                                    overlay={
                                                        <Menu className="newheader-navigation-menu">
                                                            {
                                                                value.menuList.map((m_value, m_index) => {

                                                                    if (m_value.type === 'menu') {
                                                                        return <SubMenu title={m_value.menuName}
                                                                                        key={`menu2-${m_index}`}>
                                                                            {
                                                                                m_value.menuList.map((mv, mi) => {
                                                                                    return <Menu.Item>
                                                                                        <Link
                                                                                            to={mv.link}>{mv.menuName}</Link>
                                                                                    </Menu.Item>
                                                                                })
                                                                            }
                                                                        </SubMenu>
                                                                    } else {
                                                                        return <Menu.Item key={`menu2-${m_index}`}>
                                                                            <Link
                                                                                to={m_value.link}>{m_value.menuName}</Link>
                                                                        </Menu.Item>
                                                                    }
                                                                })
                                                            }
                                                        </Menu>
                                                    }
                                                    placement="bottomLeft"
                                                >
                                                    <div className="newheader-navigation"
                                                         key={`menu1-${index}`}>{value.navigatonName}</div>
                                                </Dropdown>
                                            } else if (value.type === 'web') {
                                                return <Dropdown
                                                    overlay={
                                                        <Menu className="newheader-navigation-menu">
                                                            {
                                                                value.menuList.map((m_value, m_index) => {
                                                                    return <Menu.Item>
                                                                        <Link
                                                                            onClick={() => this.openWebPage(m_index)}>{m_value.menuName}</Link>
                                                                    </Menu.Item>
                                                                })
                                                            }
                                                        </Menu>
                                                    }
                                                    placement="bottomLeft"
                                                >
                                                    <div className="newheader-navigation">{value.navigatonName}</div>
                                                </Dropdown>
                                            } else {
                                                return <Link
                                                    to={{
                                                        pathname: value.link,
                                                        type: 'center'
                                                    }}
                                                >
                                                    <div className="newheader-navigation">{value.navigatonName}</div>
                                                </Link>
                                            }
                                        })
                                    }
                                </div>
                            </div>
                            <div className='header-user-panel'>
                                <div>
                                    <Dropdown
                                        overlay={usermenu}
                                    >
                                        <div className="newheader-username">
                                            <Avatar className='header-username-avatar' style={{marginRight: 20}}
                                                    src={this.props.user.avatar}></Avatar>
                                            {this.props.user.userName}
                                        </div>
                                    </Dropdown>
                                    <Dropdown
                                        overlay={messagemenu}
                                    >
                                        <div className="newheader-username" style={{marginLeft: 20}}>消息(2)</div>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                        <div className='newheader_toNewPage' onClick={this.jumpToNewPage}>
                            区域合作
                        </div>
                    </div>
                </div>

                // </div> 
            )
        } else //未登录状态统一退回到home （除非是在"用户注册" ‘登录’界面）
            // if (this.props.match.url === "/UserRegister") {
            // return <Redirect path='/Login' to="/UserRegister" />
            // } else {
            return <Redirect path='/Login' to='/Home'/>
        // }
    }

    jumpToNewPage = () => {
        window.location = "http://10.0.37.25:8148/#/about";
        // window.open("http://10.0.37.25:8148/#/about");
    }

    openWebPage = (num) => {
        switch (num) {
            case 0:
                window.open("https://www.baidu.com/");
                break;
            case 1:
                window.open("https://cn.bing.com/");
                break;
            case 2:
                window.open("https://www.so.com/");
                break;
            default:
                break;
        }
    }
}

/**
 *
 * @param {*} state 代表外部传来的数据
 */
const mapState = (state) => ({ //返回值对应的是组件的props
    // loginStatus: state.loginreducer.loginstate,
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
    // userName: state.loginreducer.userName
})
/**
 * 用来建立 UI 组件的参数到store.dispatch方法的映射。它定义了哪些用户的操作应该当作 Action，传给 Store。它可以是一个函数，也可以是一个对象。
 * @param {*} dispatch
 * @param {*} ownProps 容器组件的props对象
 */
const mapDispatch = (dispatch, ownProps) => ({
    //组件中的方法名称 组件通过this.props.fucname(para1,para2)来调用方法
    // { type: 'increase' }定义了外部对这个方法的描述信息，
    // login: (userName, password) => dispatch({ type: 'login', userName: userName }),
    // logout: () => dispatch({ type: 'logout' })
    login: (param) => dispatch(login(param)),
    logout: (user) => dispatch(logout(user))
})
/**
 * connect方法接受两个参数： * mapStateToProps 和 mapDispatchToProps。它们定义了 UI 组件的业务逻辑。
 * mapStateToProps 负责输入逻辑，即将state映射到 UI 组件的参数（props），
 * mapDispatchToProps 负责输出逻辑，即将用户对 UI 组件的操作映射成 Action。
 */
/**
 * 白色主题
 */
export default connect(mapState, mapDispatch)(withRouter(Header3));